<template>
  <div>
    <v-app>
      <v-img src="" class="background-display">
      <v-container>
      <v-card max-width="400" class="mx-auto ma-5">
        <v-snackbar v-model="snackbar" top :timeout="6000">
          <span>Se le ha enviado a su correo un código de confirmación para realizar el cambio de contraseña </span>
        </v-snackbar>
        <v-toolbar dark color="#00b2bb">
          <v-card-title>
            <span class="headline font-weight-thin">Nueva Contraseña</span>
          </v-card-title>
        </v-toolbar>
          <v-progress-linear v-if="apiRequest"
          indeterminate
          color="teal" dark
          ></v-progress-linear>
        <v-card-text>
          <v-alert v-model="alert" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! Email o código errado
          </v-alert>
          <v-form ref="form">
            <EmailField
                v-model="email"
                :name="email"
                :schema="{
                  label: 'Correo',
                  icon: 'mdi-email'
                }"
                solo
              >
              </EmailField>
            <PasswordField
                v-model="password"
                :name="password"
                :schema="{
                   label: 'Nueva Contraseña',
                   icon:'mdi-lock'
                 }"
                 hint="Los caracteres especiales son * _ ( ) ^ % $ # @ ! ~ ` '&'"
                >
               </PasswordField>
               <StringField
                v-model="confirmCode"
                :name="confirmCode"
                :schema="{
                   label: 'Código Confirmación',
                   icon:'mdi-account'
                 }"
               >
               </StringField>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-btn color="normal" :to="'/'">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#00b2bb" dark v-if="!alert" @click="validationRules">Cambiar</v-btn>
        </v-card-actions>
      </v-card>
      </v-container>
      </v-img>
    </v-app>
  </div>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
import EmailField from '../../components/fields/email/Field.vue'
import PasswordField from '../../components/fields/password/Field.vue'
import StringField from '../../components/fields/string/Field.vue'
// @ is an alias to /src
export default {
  name: 'ConfirmSignUp',
  components: {
    EmailField,
    PasswordField,
    StringField
  },
  data: () => ({
    showPassword: false,
    alert: false,
    apiRequest: false,
    singedIn: false,
    snackbar: false,
    email: '',
    confirmCode: '',
    password: '',
    codeRules: [
      v => !!v || 'El código es obligatorio'
    ]
  }),
  mounted () {
    this.snackbar = true
  },
  /* Metodo para saber si el usuario esta logeado */
  methods: {
    async changePassword () {
      this.apiRequest = true
      try {
        await Auth.forgotPasswordSubmit(this.email, this.confirmCode, this.password)
        this.apiRequest = false
        this.snackbar = true
        this.$router.push({ path: '/changepasswordmessage' })
      } catch (error) {
        this.alert = true
        this.apiRequest = false
        console.log(error)
      }
    },
    validationRules () {
      if (this.$refs.form.validate()) {
        this.changePassword()
      }
    }
  }
}
</script>
